import { useEffect } from 'react';

import {
    cancelLoadingIndicatorDisappearsTelemetry,
    hasEmittedLoadingIndicatorDisappearsTelemetry
} from '@makemydeal/dr-shared-ui-utils';

export const useCancelLoadTelemetryOnViewAsStart = (isViewAsRoute: boolean): void => {
    useEffect(() => {
        if (!isViewAsRoute || hasEmittedLoadingIndicatorDisappearsTelemetry()) return;
        cancelLoadingIndicatorDisappearsTelemetry();
    }, [isViewAsRoute]);
};
